import React from 'react'
import { Box, Drawer, List } from '@mui/material'
import LogoSrc from 'components/Logo/Logo.png'
import AccountMenuItems from './AccountMenuItems'

const AccountMenuDrawer = ({ isOpen, onClose }) => (
  <Drawer anchor="right" open={isOpen} onClose={onClose}>
    <Box p={2}>
      <img src={LogoSrc} alt="HiddenUnderGround" height={50} />
    </Box>
    <List sx={{ minWidth: 300 }}>
      <AccountMenuItems onNavigate={onClose} />
    </List>
  </Drawer>
)

export default AccountMenuDrawer
